import React from 'react';
import Video from '../../Components/BannerElements/Video';
import Testimonial01 from '../Testimonials/Testimonial01';
import { services } from '../../Components/SeoRoutes/SeoRoutes';
import { useLocation } from 'react-router-dom';
import AboutBelowContent from '../../Components/ExperienceBlocks/AboutBelowContent';
import Banner from '../Banner';
import categories from '../../data/categories.json';




// ... resto del codice ...

const serviceIcons = {
    'costruzione-chiavi-in-mano': '/images/icons/con-helmet.svg',
    'ristrutturazione': '/images/icons/con-hammer-screwdriver.svg',
    'miglioramento-energetico': '/images/icons/con-electricity.svg',
    'servizi-fognature': '/images/icons/con-u-bend.svg',
    'coperture': '/images/icons/con-level.svg',
    'sistemazione-esterni': '/images/icons/con-spade-fork.svg',
    'movimenti-di-terra': '/images/icons/con-digger.svg',
    'piccoli-impianti-civili': '/images/icons/con-screwdrivers.svg',
    'pavimenti-rivestimenti': '/images/icons/con-set-square.svg',
    'pitture': '/images/icons/con-roller.svg'
};

// Nel componente, modifica il rendering dell'icona:


const ServiceContainer01 = ({ description, benefits, features }) => {
    const currentPath = useLocation().pathname.slice(1);
    const basePath = currentPath.split('-a-')[0];
    
    const currentService = Object.values(services).find(service => 
        service.path === basePath
    );

    if (!currentService) {
        return <div>Servizio non trovato</div>;
    }



    return (
        <div className="main_wrapper">
            <div className="container">
                <div className="project_details section">
                    <div className="row">
                        <div className="col-lg-8 col-md-12">
                            <div className="project_details_inner">
                                <div className="post_img" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                    {currentService.images?.main ? (
                                        <img src={currentService.images.main} alt={currentService.title} style={{ borderRadius: '12px' }} />
                                    ) : (
                                        <img src="/images/services/default.jpg" alt={currentService.title} style={{ borderRadius: '12px' }} />
                                    )}
                                </div>
                                <div className="post_content">
                                    <div className="post_header">
                                        <div className="service-title-wrapper">
                                            <img 
                                                src={serviceIcons[currentPath]?.icon} 
                                                alt="" 
                                                className="service-icon"
                                            />
                                            {/* Correzione qui: renderizziamo il titolo invece dell'oggetto intero */}
                                            <h1 className="post_title">{currentService.title}</h1>
                                        </div>
                                    </div>
                                    <div className="fulltext">
                                        {currentService.detailedDescription ? 
                                            currentService.detailedDescription.map((paragraph, index) => (
                                                <p key={index}>{paragraph}</p>
                                            )) : 
                                            <p>{currentService.longDescription}</p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-12">
                            <div className="sidebar-wrapper">
                                <div className="sidebar">
                                    <div id="widgetnav" className="widget widget_menu">
                                        <div className="sidenav">
                                            <ul className="side_menu">
                                            {Object.entries(categories).map(([key, value]) => (
                                                <li key={key} className={`menu-item ${currentPath === key ? 'active' : ''}`}>
                                                    <a href={`/${key}`}>
                                                        <img 
                                                            src={serviceIcons[key]} 
                                                            alt="" 
                                                            className="menu-icon"
                                                        />
                                                        {value}
                                                    </a>
                                                </li>
                                            ))}
                                            </ul>
                                        </div>
                                    </div>

                                    <div id="custom_2" className="widget widget_side_contact">
                                        <div className="side_contact" style={{
                                            backgroundImage: 'url("/images/bg/pattern-bg.jpg")',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            position: 'relative',
                                            overflow: 'hidden'
                                        }}>
                                            {/* Overlay scuro */}
                                            <div className="dark-overlay"></div>
                                            
                                            <div className="side_contact_content">
                                                <div className="side_contact_top">
                                                    <div className="side_contact_inner">
                                                        <div className="icon-wrapper">
                                                            <i className="fa fa-phone-square"></i>
                                                        </div>
                                                        <p>Hai bisogno di un servizio?</p>
                                                        <h4>Richiedi un Preventivo</h4>
                                                    </div>
                                                </div>
                                                <a href="tel:+393405327626" className="side_phone_inner">
                                                    <i className="fa fa-phone me-2"></i>
                                                    <span>340 5327626</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceContainer01;